import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AutorizacaoService } from '@shared/infra/autorizacao/autorizacao.service';
import { SliceAuthService } from './core/autenticacao/slice-auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private sliceAuthService: SliceAuthService,
    private autorizacaoService: AutorizacaoService,
  ) {}

  ngOnInit(): void {
    this.sliceAuthService.appInit();
    this.autorizacaoService.loadAutorizacoes();
  }
}
